// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"SearchSection_searchWrapper__8C2GN","formWrapper":"SearchSection_formWrapper__1WLQ1","searchResults":"SearchSection_searchResults__2_IA-"};